import { createSlice } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  data: any[];
  status: ReduxStateType;
  filter: {
    year: number;
  };
  otherData: {
    monthYear?: string;
    salary?: string;
  };
}
const initialState: InitialState = {
  filter: { year: new Date().getFullYear() },
  data: [],
  otherData: {},
  status: ReduxStateType.INIT,
};

const getListNotifyIncomeSlice = createSlice({
  name: "getListNotifyIncomeSlice",
  initialState,
  reducers: {
    getListNotifyIncomeStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getListNotifyIncomeSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...state.data, ...action.payload.data];
    },
    getListNotifyIncomeFailed: (state, action) => {
      state.status = action?.payload ?? ReduxStateType.ERROR;
      state.data = [];
    },
    updateOtherDataNotifyIncome: (state, action) => {
      state.otherData = {
        ...state.otherData,
        ...action.payload,
      };
    },
    resetDataListNotifyIncome: (state) => {
      state.data = [];
      state.otherData = {};
    },
    resetGetListNotifyIncome: (state) => initialState,
    updateFilterYearNotifyIncome: (state, action) => {
      Object.assign(state.filter, action.payload);
    },
  },
});

export const {
  getListNotifyIncomeStart,
  getListNotifyIncomeSuccess,
  getListNotifyIncomeFailed,
  resetGetListNotifyIncome,
  updateFilterYearNotifyIncome,
  updateOtherDataNotifyIncome,
  resetDataListNotifyIncome,
} = getListNotifyIncomeSlice.actions;

export default getListNotifyIncomeSlice.reducer;
